import { render } from "./MyClassMates.vue?vue&type=template&id=79880584"
import script from "./MyClassMates.vue?vue&type=script&lang=js"
export * from "./MyClassMates.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__